<section class="activity-feed">
  <h2 class="activity-feed__title">{{ titleText }}</h2>

  <div class="activity-feed__card">
    <div class="activity-feed__head">
      <div class="activity-feed__head-left">
        <span class="activity-feed__dot"></span>
        <span class="activity-feed__head-title">{{ headTitleText }}</span>
      </div>
      <span class="activity-feed__badge">{{ badgeText }}</span>
    </div>

    <div class="activity-feed__list">
      <div class="activity-feed__scroll" *ngIf="!isLoading; else activitySkeleton" [style.animation-duration.s]="scrollDurationSeconds">
        <article class="activity-feed__item" *ngFor="let item of loopingItems">
          <span class="activity-feed__avatar" [style.background]="item.color">
            {{ item.initials }}
          </span>
          <div class="activity-feed__info">
            <p class="activity-feed__text">
              <strong>{{ item.title }}</strong>
              {{ getActionText(item) }}
            </p>
            <p class="activity-feed__meta">{{ getMetaText(item) }}</p>
          </div>
        </article>
      </div>
      <ng-template #activitySkeleton>
        <article class="activity-feed__item activity-feed__item--skeleton" *ngFor="let _ of skeletonItems">
          <span class="activity-feed__skeleton activity-feed__skeleton--avatar"></span>
          <div class="activity-feed__info">
            <p class="activity-feed__skeleton activity-feed__skeleton--text"></p>
            <p class="activity-feed__skeleton activity-feed__skeleton--meta"></p>
          </div>
        </article>
      </ng-template>
    </div>
  </div>
</section>
